export const blobToBase64 = async (blob: Blob) => {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result === null) {
                reject();

            }
            resolve((reader.result as string).split("base64,")[1]);
        };
        reader.readAsDataURL(blob);
    });
}
